export class Senha {
    id:number;
    senhaAtual: string;
    senha: string;
    chave: string;
  }
  
